module.exports = __webpack_public_path__ + "static/img/fake-youtube-video.2afb365.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fake-youtube-video.png
// module id = O9QE
// module chunks = 1